var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUg = function SvgIconUg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M20.943 20A11.95 11.95 0 0 0 24 12c0-3.074-1.156-5.877-3.057-8L12 3.13 3.057 4A11.95 11.95 0 0 0 0 12c0 3.074 1.156 5.877 3.057 8l8.943.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.057 4h17.886A11.97 11.97 0 0 0 12 0a11.97 11.97 0 0 0-8.943 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m0 12 12 1.044 12-1.043c0-1.403-.241-2.75-.684-4H.684A12 12 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.684 16h22.632A12 12 0 0 0 24 12H0c0 1.402.241 2.748.684 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.944 20H3.057c2.197 2.454 5.39 4 8.943 4s6.746-1.546 8.944-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.004 12a4.004 4.004 0 1 1-8.008.001 4.004 4.004 0 0 1 8.008 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.467 12.204 12 11.568s.343-1.14.361-1.217a.78.78 0 0 0-.209-.73l.37-.37a1.3 1.3 0 0 0-1.845 0l.369.37a.78.78 0 0 0-.196.78l-.555.555h1.01s-.418.627-.646 1.142a1.053 1.053 0 0 0 .53 1.377l.304.135.507.476v.522l-.522.522h1.044v-1.044l.476-.476h.985l.014-.03a1.044 1.044 0 0 0-.53-1.376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconUg;